import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { OtpInputComponent } from '@app/shared/components/otp-input/otp-input.component';
import { LoginStateEnum } from '@app/authentication/login/login-state.enum';
import { CodeInputState } from '@app/authentication/shared/components/code-input/code-input-state';

@Component({
  selector: 'app-login-2fa',
  templateUrl: './2fa-login.component.html',
  standalone: false,
})
export class TwoFaLoginComponent implements OnChanges {
  @ViewChild('otpInputComponent') otpInputComponent!: OtpInputComponent;
  @Input() email = '';
  @Input() waiting!: boolean;
  @Input() type!: LoginStateEnum.confirmationEmail | LoginStateEnum.twoFactorEmail | LoginStateEnum.twoFactorGoogle;
  @Output() twoFactorCodeEmitter = new EventEmitter<string>();

  codeInputState: CodeInputState = { code: '', isComplete: false };

  ngOnChanges(changes: SimpleChanges) {
    if (changes.type.previousValue !== changes.type.currentValue) {
      this.resetCode();
    }
  }

  iconType(): string {
    switch (this.type) {
      case LoginStateEnum.confirmationEmail:
      case LoginStateEnum.twoFactorEmail:
        return 'email';
      default:
        return 'trezor';
    }
  }

  iconLabelType(): string {
    switch (this.type) {
      case LoginStateEnum.confirmationEmail:
      case LoginStateEnum.twoFactorEmail:
        return 'login.2fa.email';
      default:
        return 'login.2fa.authenticator';
    }
  }

  titleType(): string {
    switch (this.type) {
      case LoginStateEnum.confirmationEmail:
        return 'login.2fa.unknown-device';
      case LoginStateEnum.twoFactorEmail:
        return 'login.2fa.2fa-safety';
      default:
        return 'login.2fa.2fa-google';
    }
  }

  descriptionType(): string {
    return this.isGoogleAuth() ? 'login.2fa.enter-2fa-app-title' : 'login.2fa.enter-2fa-mail-title';
  }

  labelType(): string {
    return this.isGoogleAuth() ? 'login.2fa.enter-2fa-app-label' : 'login.2fa.enter-2fa-mail-label';
  }

  isGoogleAuth(): boolean {
    return this.type === LoginStateEnum.twoFactorGoogle;
  }

  onCodeCompleted(code: string) {
    this.codeInputState.code = code;
    this.codeInputState.isComplete = true;
    this.submitCode();
  }

  submitCode() {
    this.twoFactorCodeEmitter.emit(this.codeInputState.code);
  }

  resetCode() {
    if (this.otpInputComponent) {
      this.otpInputComponent.resetCodeInput();
      this.otpInputComponent.focusOnField(0);
    }
  }
}
